import React from 'react'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Skeleton from '@mui/material/Skeleton'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import palette from '../../../../theme/palette'

function getFRTColor(minutes) {
  if (minutes == null) return palette.grey[500]
  if (minutes < 60) return palette.success.main
  if (minutes < 120) return palette.warning.main
  return palette.error.main
}

function formatDuration(minutes) {
  if (minutes == null) return '—'
  if (minutes < 60) return `${Math.round(minutes)}m`
  const h = Math.floor(minutes / 60)
  const m = Math.round(minutes % 60)
  return m > 0 ? `${h}h ${m}m` : `${h}h`
}

export default function FRTDisplay({ avg, p50, p90, loading }) {
  if (loading) {
    return (
      <Paper sx={{ p: 2.5 }}>
        <Skeleton width={120} height={20} />
        <Skeleton width={80} height={48} sx={{ mt: 1 }} />
        <Skeleton width={160} height={16} sx={{ mt: 1 }} />
      </Paper>
    )
  }

  const color = getFRTColor(avg)

  return (
    <Paper sx={{ p: 2.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <AccessTimeIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
        <Typography variant='subtitle1'>First Response Time</Typography>
      </Box>

      <Typography variant='h4' sx={{ fontWeight: 800, color }}>
        {formatDuration(avg)}
      </Typography>
      <Typography variant='caption' sx={{ color: 'text.disabled' }}>average</Typography>

      <Box sx={{ display: 'flex', gap: 3, mt: 2 }}>
        <Box>
          <Typography variant='body2' sx={{ fontWeight: 700, color: getFRTColor(p50) }}>
            {formatDuration(p50)}
          </Typography>
          <Typography variant='caption' sx={{ color: 'text.disabled' }}>P50 (median)</Typography>
        </Box>
        <Box>
          <Typography variant='body2' sx={{ fontWeight: 700, color: getFRTColor(p90) }}>
            {formatDuration(p90)}
          </Typography>
          <Typography variant='caption' sx={{ color: 'text.disabled' }}>P90</Typography>
        </Box>
      </Box>

      <Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {[
          { label: '< 1h', color: palette.success.main, bg: palette.success.lighter },
          { label: '1–2h', color: palette.warning.main, bg: palette.warning.lighter },
          { label: '> 2h', color: palette.error.main, bg: palette.error.lighter },
        ].map(b => (
          <Box key={b.label} sx={{ px: 1, py: 0.25, borderRadius: 1, bgcolor: b.bg, color: b.color, fontSize: '0.68rem', fontWeight: 700 }}>
            {b.label}
          </Box>
        ))}
      </Box>
    </Paper>
  )
}
